import { Link } from "react-router-dom";
import logoWhite from "../../../assets/general/logo-white.svg";
import { MobileMenuToggle } from "./MobileMenuToggle";
import { SideNav } from "../SideNav/SideNav";

interface HeaderProps {
  onContactUs: () => void;
  onLegal: () => void;
  onMobileMenuToggle: () => void;
  isMobileMenuOpen: boolean;
}

export function Header({
  onContactUs,
  onLegal,
  onMobileMenuToggle,
  isMobileMenuOpen,
}: HeaderProps) {
  return (
    <>
      <div className="header-container">
        <Link className="logo" to="/">
          <div className="logo__wrapper-img">
            <img className="logo-img" src={logoWhite} alt="360PLUS Website" />
          </div>
        </Link>
        <MobileMenuToggle isOpen={isMobileMenuOpen} onToggle={onMobileMenuToggle} />
      </div>

      <SideNav onContactUs={onContactUs} onLegal={onLegal} />
    </>
  );
}
